import React, { PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import styled from '@mui/material/styles/styled';
import { AppBar, SideDrawer } from '@/components/Navigation';
import useQualityInitializer from 'hooks/useQualityInitializer';

type Props = PropsWithChildren<{
    sidebar?: boolean;
    topbar?: boolean;
}>;

const BaseLayout: React.FC<Props> = ({ children, sidebar, topbar }) => {
    const Offset = styled('div')(({ theme }) => theme.mixins.toolbar);

    //! topbar & sidebar are too strictly attached to the redux store
    const { loading } = useQualityInitializer();

    const drawerWidth = '254px';
    const topbarEl = !loading && topbar && <AppBar drawerWidth={drawerWidth} />;
    const sidebarEl = !loading && sidebar && (
        <SideDrawer drawerWidth={drawerWidth} />
    );

    return (
        <Box display="flex">
            {topbarEl}
            {sidebarEl}
            <Container
                maxWidth="xl"
                component="main"
                sx={{ flexGrow: 1, paddingTop: 3 }}
            >
                <Box sx={{ flexGrow: 1 }} marginBottom="64px">
                    {sidebar && <Offset />}
                    {children}
                    <Outlet />
                </Box>
            </Container>
        </Box>
    );
};

export default BaseLayout;
